import {
  Box,
  FormControl,
  FormHelperText,
  FormLabel,
  LinearProgress,
  Typography,
  useTheme
} from '@mui/material';

import { appFormUtil } from 'modules/common';
import { FileUploadField } from 'modules/components/layer00';
import * as ds from './dataService';
import React, { ReactNode } from 'react';


export type StyledPhotoUploadFieldProps<T extends object> = {
  form: appFormUtil.InferReturn<T>;
  formFieldPropertyName: keyof appFormUtil.InferReturn<T>['formState'];
  formFieldUrlPropertyName: keyof appFormUtil.InferReturn<T>['formState'];
  formLabel?: string;
  required?: boolean;
  validationErrorMessage?: string;
  children?: ReactNode | ReactNode[];
};

export const FC = <T extends object>(props: StyledPhotoUploadFieldProps<T>) => {
  const [
    fnQuery,
    queryTuple
  ] = ds.useQuery();

  const theme = useTheme();



  return (
    <FormControl
      fullWidth
      required={props.required}
      error={props.validationErrorMessage && props.validationErrorMessage?.length > 1 ? true : false}
    >
      <FormLabel
        sx={{
          marginBottom: '.75rem'
        }}
      >
        <Typography
          variant='formLabel'
        >
          {props.formLabel}
        </Typography>
      </FormLabel>

      <FileUploadField.FC
        onUploadedFile={async (apiFileId) => {
          props.form.dispatch(
            {
              type: 'UPDATE',
              payload: {
                property: props.formFieldPropertyName,
                value: apiFileId as T[keyof T]
              }
            }
          );

          fnQuery(apiFileId);
        }}
      >
        {(handleClick, isLoading) => (
          (isLoading || queryTuple.loading)
            ? (
              <LinearProgress
                variant='indeterminate'
              />
            )
            : (
              (queryTuple.data.fileName)
                ? (
                  <Box
                    display='flex'
                    padding='1rem'
                    flexDirection='row'
                    borderRadius='1.5rem'
                    columnGap='1rem'
                    bgcolor={theme.palette.secondary.main}
                    justifyContent='center'
                    onClick={() => handleClick()}
                  >
                    {/* THIS IS WHERE MODIFY WHAT SHOWS AFTER THE FILE IS UPLOADED */}
                    <Box
                      maxWidth='25%'
                      component='img'
                      src={queryTuple.data.url}
                    />
                  </Box>
                )
                : (
                  <Box
                    display='flex'
                    padding='1rem'
                    onClick={() => handleClick()}
                    flexDirection='row'
                    justifyContent='center'
                    alignItems='center'
                    sx={{
                      borderRadius: '1.5rem',
                      border: `1px dashed ${theme.palette.primary.main}`
                    }}
                  >
                    {props.children}
                  </Box>
                )))}
      </FileUploadField.FC>
      {
        props.validationErrorMessage && props.validationErrorMessage.length > 1
          ? (
            <FormHelperText variant='standard'>
              {props.validationErrorMessage}
            </FormHelperText>
          )
          : (<></>)
      }
    </FormControl>
  );
};
